// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { screenCheckLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-screen-check-lines': IconScreenCheckLines;
    }
}

/**
 * The icon component for the 'screenCheckLines' icon
 */
export class IconScreenCheckLines extends IconSvg {
    public constructor() {
        super(screenCheckLines16X16);
    }
}

registerIconSvg('icon-screen-check-lines', IconScreenCheckLines);
export const iconScreenCheckLinesTag = 'nimble-icon-screen-check-lines';
